import { LoadingIcon } from '../base/loading-screen';

interface DomainLoadingScreenProps {
  domainName?: string;
}

export const DomainLoadingScreen: React.FC<DomainLoadingScreenProps> = ({ domainName }) => {
  return (
    <div className="flex items-center justify-center min-h-screen">
      <LoadingIcon message={domainName ? `Loading ${domainName}...` : 'Loading...'} />
    </div>
  );
};
